module.exports = __webpack_public_path__ + "static/media/sug.9154928a.png";